import { render, staticRenderFns } from "./VFile.vue?vue&type=template&id=ed59b3e8&scoped=true"
import script from "./VFile.vue?vue&type=script&lang=js"
export * from "./VFile.vue?vue&type=script&lang=js"
import style0 from "./VFile.vue?vue&type=style&index=0&id=ed59b3e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed59b3e8",
  null
  
)

export default component.exports